import React from 'react';
import './Tag.css';
import { Tag as TagType } from '../../types/types';
interface TagProps {
  tag: TagType
  onClick?: () => void
}

const likelihoodClassNames = {
  'Extremely Likely': 'tag--likely',
  'Likely': 'tag--likely',
  'Moderate': 'tag--moderate',
  'Unlikely': 'tag--unlikely',
  'Extremely Unlikely': 'tag--unlikely',
}

const Tag: React.FC<TagProps> = ({ tag, onClick }) => {
  const { frame: text, likelihood } = tag;

  const tagClass = `tag tag-${text.toLowerCase().replace('/', '-').replace(' ', '-')}`;
  const likelihoodClass = likelihoodClassNames[likelihood] || 'tag--unlikely';
  const selected = tag.deselected ? 'tag--deselected' : 'tag--selected';
  const clickable = onClick ? 'tag--clickable' : '';
  return (
    <div className={`${tagClass} ${likelihoodClass} ${selected} ${clickable}`} onClick={onClick}>
      {/* <div className={likelihoodClass}> */}
        {text}
      {/* </div> */}
    </div>
  );
};

export default Tag;